import {
  Layout,
  Button,
  Input,
  message,
  Table,
  ConfigProvider,
  Row,
  Col,
  Popconfirm,
  Pagination,
  Modal,
} from 'antd'
import { Content } from 'antd/lib/layout/layout'
import zhCN from 'antd/lib/locale/zh_CN'
import OAMSider from '../oam-sider'
import React, { useEffect, useRef, useState } from 'react'
import { sendHttpPostRequest } from '../../../api/http-request'
import Cookies from 'js-cookie'

import Draggable from 'react-draggable'
import idataCourseTableStyles from '../../common/global-styles/idatacoding.module.less'




export interface Props {}

/** OAM 项目分类列表页 */
export const OAMCategoryList: React.FC<Props> = (props) => {
  const [categoryResult, setCategoryResult] = useState([] as any[]) // 当前显示的结果页
  const [resultSum, setResultSum] = useState(0) // 搜索返回的结果数
  const queryContent = useRef('') // 记录搜索串
  const page = useRef(1) // 记录当前的页数
  const pageSize = useRef(10) // 记录当前每页展示数量

  /* 创建实验相关 */
  const [isModalVisible, setIsModalVisible] = useState(false)
  const draggleRef = useRef<HTMLDivElement | null>(null)
  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
  const [disabled, setDisabled] = useState(true)

  const [categoryName, setCategoryName] = useState('')

  useEffect(() => {
    queryAllCategoryList()
  }, [])


      /**
   * 查询项目分类列表
   */
  const queryAllCategoryList = () => {
    sendHttpPostRequest(
      'course/api/oam_query_project_category',

      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        page: page.current,
        pagesize: pageSize.current,

      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
        } else if (response.is_ok == true) {
          // 成功
          setCategoryResult(response?.data?.list)
          setResultSum(response?.data?.total_sum)
        }
      }
    )
    
  }
  
  // 创建项目分类回调
  const createCategoryCallback = (response: any) => {
    message.destroy()
    if (response.is_ok) {
      message.success(response.message)
      queryAllCategoryList()
    } else {
      message.error(`创建项目分类失败${response.message}`)
    }
  }

  /**
   * 点击创建项目分类
   */
  const createCategory = () => {
    message.destroy()
    const requestParams = {
      sessionid: Cookies.get('sessionid'),
      name: categoryName,
    }
    sendHttpPostRequest(
      'course/api/oam_create_project_category',
      requestParams,
      createCategoryCallback
    )
  }

  const onStart = (event: any, uiData: any) => {
    const { clientWidth, clientHeight } = window?.document?.documentElement
    const targetRect = draggleRef?.current?.getBoundingClientRect()
    if (targetRect) {
      setBounds({
        left: -targetRect?.left + uiData?.x,
        right: clientWidth - (targetRect?.right - uiData?.x),
        top: -targetRect?.top + uiData?.y,
        bottom: clientHeight - (targetRect?.bottom - uiData?.y),
      })
    }
  }

  const handleOk = () => {
    //确认创建分类
    message.destroy()
    if (categoryName.trim() == '') {
      message.error('请输入项目分类名称')
    }else {
      createCategory()
      setIsModalVisible(false)
    }
  }

  const showModal = () => {
    setIsModalVisible(true)
  }

  const handleCancel = () => {
    setIsModalVisible(false)
  }

  // 分类名称改变
  const onNameChange = (key: string, event: any) => {
    setCategoryName(event.target.value)
  }



  //页码和页数发生了变化
  const onPageChange = (newPage: number, newPageSize?: number | undefined) => {
    page.current = newPage ? newPage : 1
    if (newPageSize) {
      pageSize.current = newPageSize
    }
    queryAllCategoryList()
  }

  // 删除回调
  const onDeleteBtnClickCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 没登录
      window.location.href = '/oam_login?next=oam_category_list'
    } else if (response.code == -501) {
      // 没权限
      window.location.href = '/oam_login?next=oam_category_list'
    } else if (response.code == 0) {
      message.success(response.message)
      queryAllCategoryList()
    } else {
      message.error(response.message)
      queryAllCategoryList()
    }
  }

  // 点击 删除
  const onDeleteBtnClick = (categoryId: string) => {
    sendHttpPostRequest(
      'course/api/oam_delete_project_category',
      {
        sessionid: Cookies.get('sessionid'),
        category_id: categoryId,
      },
      onDeleteBtnClickCallback
    )
  }

  // 渲染操作
  const renderActions = (text: any, record: any) => {

      return (
        <Row
          justify="center"
          align="middle"
          style={{ gap: '10px' }}
          wrap={false}
        >

          <Col>

          <Popconfirm
                placement="top"
                title={'确认删除分类"' + record.name + '"吗？'}
                onConfirm={onDeleteBtnClick.bind(this, record.id)}
                okText="确认"
                cancelText="取消"
              >
              <Button
                style={{ borderRadius: 20, fontSize: 14 }}
                size="small"
                id="deleteexe"
                type="dashed"
                danger
                
              >
                {' '}
                删除
              </Button>
            </Popconfirm>
          </Col>
        
        </Row>
      )
     
  }


  //点击了搜索按钮
  const onSearchBtn = (value: string) => {
    page.current = 1
    queryContent.current = value
    queryAllCategoryList()
  }



  // 表格发生变化
  const onTableChange: any = (
    pagination: any,
    filters: any,
    sorter: any,
    extra: { currentDataSource: []; action: any }
  ) => {
  
    page.current = 1
    queryAllCategoryList()
  }

  const columns: any = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      align: 'left',
      width: 100,
      ellipsis: true,
    },
    {
      title: '分类名称',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      align: 'left',
      width: 150,
      render: (t, r, i) => (
        <span
         
        >
          {t}
        </span>
      ),

    },

    {
      title: '操作',
      dataIndex: 'actions',
      key: 'actions',
      width: 150,
      ellipsis: true,
      align: 'center',
      fixed: 'right',
      render: renderActions,
    },
  ]

  return (
    <Layout style={{ minHeight: '100vh',minWidth:1200 }}>
      <OAMSider keys={'88'} openKeys={['sub-project']}></OAMSider>
      <Layout style={{ backgroundColor: '#f9f9f9' }}>
        <Content
          style={{
            backgroundColor: '#fff',
            borderRadius: 5,
            minWidth: 400,
            margin: 30,
            paddingTop: 20,
          }}
        >
          <div style={{ paddingLeft: 30, paddingRight: 30, paddingBottom: 30 }}>
            <Row align="middle" gutter={16} style={{marginBottom:12}}>
              <Col flex="250px">

              </Col>
              <Col flex="auto" style={{ textAlign: 'right' }}>
                <Button
                  type="primary"
                  style={{ float: 'right', marginRight: 20, borderRadius: 20, textShadow:'none', boxShadow:'none' }}
                  onClick={showModal}
                >
                  创建分类
                </Button>
                <ConfigProvider locale={zhCN}>
                  <Modal
                    title={
                      <div
                        style={{
                          width: '100%',
                          cursor: 'move',
                        }}
                        onMouseOver={() => {
                          if (disabled) {
                            setDisabled(false)
                          }
                        }}
                        onMouseOut={() => {
                          setDisabled(true)
                        }}
                        onFocus={() => {}}
                        onBlur={() => {}}
  
                      >
                        创建分类
                      </div>
                    }
                    closable={false}
                    open={isModalVisible}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    bodyStyle={{  }}
                    destroyOnClose={true}
    
                    modalRender={(modal) => (
                      <div style={{width:600}} 
        
                      >
                        <Draggable
                          disabled={disabled}
                          bounds={bounds}
                          onStart={(event, uiData) => onStart(event, uiData)}
                        >
                          <div ref={draggleRef}>{modal}</div>
                        </Draggable>{' '}
                      </div>
                    )}
                  >
                    <Row
                      gutter={[8, 8]}
                      justify="start"
                      align="middle"
                      style={{ marginBottom: 20 }}
                    >
                      <Col
                        flex="100px"
                        style={{ textAlign: 'left', marginLeft: 50 }}
                      >
                        分类名称
                      </Col>
                      <Col flex="auto" style={{ textAlign: 'left' }}>
                        <Input
                          maxLength={40}
                          onChange={onNameChange.bind(this, 'name')}
                          placeholder="请输入项目分类名称"
                          required={true}
                          style={{ width: '100%' }}
                        />
                      </Col>
                      <Col flex="100px"></Col>
                    </Row>


                  </Modal>
                </ConfigProvider>
              </Col>
            </Row>



            <div style={{minHeight:500}}  className={idataCourseTableStyles.tableWrapper}>
              <ConfigProvider locale={zhCN}>
                <Table
                  dataSource={categoryResult}
                  columns={columns}
                  rowKey={(record) => record.id}
                  pagination={false}
                  scroll={{ x: 800 }}
                  onChange={onTableChange}
                />
              </ConfigProvider>
            </div>
  

            <ConfigProvider locale={zhCN}>
              <div
                style={{ marginBottom: 30, textAlign:'center'}}
                className={'css.pagination'}
              >
                <Pagination
                  defaultCurrent={1}
                  total={resultSum}
                  defaultPageSize={10}
                  current={page.current}
                  hideOnSinglePage={true}
                  onChange={onPageChange}
                  showQuickJumper={true}
                  showSizeChanger={false}
                />
              </div>
            </ConfigProvider>
          </div>
        </Content>

      </Layout>
    </Layout>
  )
}

export default OAMCategoryList
